import Axios from "axios";
import { domain } from "./../global/domain";

Axios.defaults.headers.common = {
  Authorization: `Bearer ${localStorage.getItem("token")}`,
};

export async function addCourse(data) {
  try {
    const response = await Axios.post(
      `https://${domain}/courses/follow-up/`,
      data
    );
    return response;
  } catch (error) {
    return { error, isError: true };
  }
}

export async function updateCourse(id, data) {
  try {
    const response = await Axios.patch(
      `https://${domain}/courses/follow-up/${id}/`,
      data
    );
    return response;
  } catch (error) {
    return { error, isError: true };
  }
}

export async function deleteCourse(id) {
  try {
    const response = await Axios.delete(
      `https://${domain}/courses/follow-up/${id}`
    );
    return response;
  } catch (error) {
    return { error, isError: true };
  }
}
